export default __webpack_public_path__ + "static/media/sidePink_diffuse-min.7c5c4062.jpg";